/**
 * API Configuration
 * Centralized API base URL configuration for all API calls
 */

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH_ME: `${API_BASE_URL}/api/auth/me`,
  AUTH_LOGIN: `${API_BASE_URL}/api/auth/login`,

  // Admin endpoints
  ADMIN_STATS: (tenantId: string) => `${API_BASE_URL}/api/admin/stats?tenant_id=${tenantId}`,
  ADMIN_BOOKINGS: (tenantId: string) => `${API_BASE_URL}/api/admin/bookings?tenant_id=${tenantId}`,
  ADMIN_ACCOMMODATIONS: (tenantId: string) => `${API_BASE_URL}/api/admin/accommodations?tenant_id=${tenantId}`,
  ADMIN_ACTIVITIES: (tenantId: string) => `${API_BASE_URL}/api/admin/activities?tenant_id=${tenantId}`,
  ADMIN_PACKAGES: (tenantId: string) => `${API_BASE_URL}/api/admin/packages?tenant_id=${tenantId}`,

  // Public endpoints
  SEARCH: `${API_BASE_URL}/api/search`,
  CHAT: `${API_BASE_URL}/api/chat`,
  HEALTH: `${API_BASE_URL}/health`,
};

/**
 * Helper function to get image URL.
 * Backend provides full URLs - this just handles empty/null cases.
 */
export const getImageUrl = (imagePath: string | null | undefined): string => {
  return imagePath || '';
};
